// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"751ff2a7","393":"d7db2bb5","640":"0de6502b","905":"7c9343b9"}[chunkId] + ".chunk.js";
};